// Banner scorrevole (marquee) mostrato in cima alle vetrine pubbliche degli
// stakeholder. Recupera l'avviso attivo per owner_id; se non c'e', non renderizza nulla.
import React, { useEffect, useState } from 'react';
import { bannerService } from '@/services/banner.service';
import { Info, Megaphone, AlertTriangle, PartyPopper } from 'lucide-react';

const TONE = {
  info: { cls: 'bg-primary text-primary-foreground', Icon: Info },
  promo: { cls: 'bg-emerald-600 text-white', Icon: PartyPopper },
  warning: { cls: 'bg-amber-500 text-amber-950', Icon: AlertTriangle },
  success: { cls: 'bg-emerald-500 text-white', Icon: Megaphone },
};

/**
 * @param {{ ownerId?: string, banner?: {active:boolean,message:string,tone:string} }} props
 * Passare `banner` per l'anteprima; altrimenti viene recuperato via `ownerId`.
 */
export const StorefrontBanner = ({ ownerId, banner: preview }) => {
  const [banner, setBanner] = useState(preview || null);

  useEffect(() => {
    if (preview !== undefined) { setBanner(preview); return; }
    let alive = true;
    if (!ownerId) return undefined;
    bannerService.publicBanner(ownerId)
      .then((b) => { if (alive) setBanner(b); })
      .catch(() => { if (alive) setBanner(null); });
    return () => { alive = false; };
  }, [ownerId, preview]);

  if (!banner || !banner.active || !banner.message) return null;

  const tone = TONE[banner.tone] || TONE.info;
  const { Icon } = tone;
  // Ripeto il messaggio per un flusso continuo senza vuoti.
  const items = [0, 1, 2];

  return (
    <div
      className={`relative flex items-center overflow-hidden ${tone.cls}`}
      role="status"
      aria-live="polite"
      data-testid="storefront-banner"
    >
      <span className="z-10 flex shrink-0 items-center gap-2 bg-inherit px-4 py-2 font-semibold shadow-[6px_0_10px_-4px_rgba(0,0,0,0.35)]">
        <Icon className="h-4 w-4" />
        <span className="hidden sm:inline">Avviso</span>
      </span>
      <div className="marquee-track flex min-w-full shrink-0 items-center gap-16 py-2 pl-4">
        {items.map((i) => (
          <span key={i} className="whitespace-nowrap text-sm font-medium" aria-hidden={i > 0}>
            {banner.message}
          </span>
        ))}
      </div>
    </div>
  );
};

export default StorefrontBanner;
